module.exports = __webpack_public_path__ + "static/media/fase0.01742351.jpg";